import React, { Component } from 'react'
import { Form,Input,Button} from 'element-react';
import QueryStepBar from "../../components/queryStepBar";
import nodataimgurl from "../../assets/nodata@2x.png";
import cusUtilFn from "../../utils/cusUtilFn"
import _hbzwfwJssdk from "../../utils/hbzwfwJssdk"
const hbzwfwJssdk = window.hbzwfwJssdk;
class preFirst extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title:"老年人优待证办理",
      fitrange:"武汉市",
      stepData:['校验信息','提交申请','查看状态'],
      curstep:0, //导航条
      name:'',
      cardno:'',
      isName:0,
      isCardNo:0,
      isQueryed:false
    }
  }
  componentDidMount() {

  }

  handleNameBlur=(e)=>{
    let isName=-1,value=e.target.value;
    value=value.trim();
    isName=cusUtilFn.isName(value);
    this.setState({
      name:value,
      isName:isName
    })
  }
  handleIdCardBlur=(e)=>{
    let isCardNo=-1,value=e.target.value;
    value=value.trim();
    isCardNo=cusUtilFn.isCardNo(value);
    this.setState({
      cardno:value,
      isCardNo:isCardNo
    })
  }
  handleIconClick=(e)=>{
    this.setState({
      cardno:'',
      isCardNo:0
    })
  }
  //提交
  submit(){
    let that=this,{title,cardno,isName,isCardNo}=this.state;
    let phoneTip="";
    if(isName===0){
      phoneTip="姓名不能为空"
    }else if(isName===1){
      phoneTip="姓名格式错误"
    }else if(isCardNo===0){
      phoneTip="身份证不能为空"
    }else if(isCardNo===1){
      phoneTip="身份证格式错误"
    }else{
      phoneTip=""
    }
    if(!!phoneTip){
    hbzwfwJssdk.notice.prompt({
      isSuccess: 'error',
      prompt_text: "查询失败",
      prompt_text_detail:phoneTip,
      btnArray:[]
    })
    return;}
    this.syncGetResult((cardno,resdata)=>{
      if(resdata.statuscode==='1'){
        let data={}
        if(resdata.hasProgressInfo==='0'){
          data={
            resdata:{
              cardno:cardno,
              result:resdata
            }
          }
          this.props.history.push({pathname:'/oldmanAccreditZw/index',state:data})
        }else if(resdata.hasProgressInfo==='1'){
          data={
            resdata:{
              cardno:cardno,
              result:resdata
            }
          }
          this.props.history.push({pathname:'/oldmanAccreditZw/detail',state:data})
        }
      }else if(resdata.statuscode==='103'){
        this.setState({
          isQueryed:true
        })
      }
    });
  }
  //身份证异步获取是否可办老年人优待证
  syncGetResult(callback){
    let that=this,{cardno}=this.state;
    let param={
      cardno:cardno
    }
    _hbzwfwJssdk.requestHeaderNewWork(
      `/781361e3205a4d75bdf94e9c4121f564`,
      "POST",
      {'X-hbzw-Api-Key':'d2338889-cda4-48e6-b791-5ead54787314'},
      param,
      (res) => {
        let resdata=res.data;
        callback(cardno,resdata)
      },
      (error) => {
        console.log(error,"error") 
      }
    )
  }
  getSearchString(key, Url) {
    var str = Url;
    var arr = str.split("?");
    var splitArr=arr[1].split("&");
    var obj = new Object();
    for (var i = 0; i < splitArr.length; i++) {
      var tmp_arr = splitArr[i].split("=");
      obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
    }
    return obj[key];
  }

  render() {
    let that=this,{name,cardno,isQueryed}=this.state;
    let DOM =<div>
      <div className="contain">
        <div className="formBox">
          <Form
            ref="form"
            labelPosition="left"
            labelWidth="100px"
            className="formDiv"
          >
            <Form.Item
            className="formIpt"
            label="姓名"
            >  
              <Input
                  maxLength={20}
                  ref="name"
                  placeholder="请输入姓名"
                  onBlur={(e)=>this.handleNameBlur(e)}
                ></Input> 
            </Form.Item>
            <Form.Item
             className="formIpt"
              label="身份证号"
            >  
              <Input
                  maxLength={18}
                  ref="cardno"
                  placeholder="请输入身份证号"
                  onBlur={e=>{this.handleIdCardBlur(e)}}
                ></Input> 
            </Form.Item>
            <Form.Item
              label="">  
              <Button type="primary" className="cus-btn1" onClick={()=>{this.submit()}}>查询</Button>
            </Form.Item>
          </Form>
        </div>
    </div>

      <div className="despBox">
        <div className="despTtl">
        查询说明： 
        </div>
        <div className="despTxt">
          1、请先输入信息查询您是否可以办理及办理状态<br></br>
        </div>
      </div>
    </div>
        

   return (
      <div className="cusStl oldmanAccredit w-auto">
        <div className="navBar">
          <div className="navBar_text"> {this.state.title}</div>
        </div>
        <QueryStepBar datas={this.state.stepData} curstep={this.state.curstep}/>

        {!isQueryed?DOM:(
          <div className="noDataBox">
            <div className="nodataTip">
            <img src={nodataimgurl}></img>
            <span>暂未查询到您的信息，请确认后重试</span>
            </div>

            <div className="despBox">
            <div className="despTtl">
            服务说明：
            </div>
            <div className="despTxt">
              1、老年人优待证权益同老年证相同<br></br>
              2、老年人优待证的办理对象为具有武汉市户籍且年满60周岁的老年人，或在武汉市常住且取得了《武汉市居民证》年满60周岁的老年人<br></br>
              3、此次查询是查询您的备案信息，如未查询到您的信息，请确认您的身份证号是否正确或是否具备办理条件，如非以上原因，请联系当地街道办事处或政务中心<br></br>
              4、本服务目前仅支持新证办理，如需补办请前往当地街道办事处或政务中心<br></br>
              5、如有疑问请联系客服处理<br></br>
            </div>
            </div>
          </div>)
        }  
      </div>
    )

  }
}

export default preFirst